import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';

export default class OrderSummaryPageController{
    static $inject = ['$scope', '$state', 'CartService','OrderSetupService','ConfigurationService','GroupOrder'];

    constructor(scope, stateService,cartService,orderSetupService,configurationService,groupOrderService){
        this._scope = scope;
        this._stateService = stateService;
        this._cartService = cartService;
        this._orderSetupService = orderSetupService;
        this._configurationService = configurationService;
        this._groupOrderService = groupOrderService;
        
        scope.submitOrder = () => this._submitOrder();
        scope.invitationCode = this._cartService.getInviteCode();
        scope.invitationLink = '';
        this._initialize();
    }
   
    async _initialize(){
        var _retailer = this._configurationService.getRetailer().retailer;
        if(_retailer.retailerType === 'Shopify'){
            this._scope.invitationLink = 'https://' + _retailer.website + '#/invite/';
        }else{
            this._scope.invitationLink = _retailer.website + '#/invite/';
        }
        if(!this._scope.invitationCode){
            this._scope.invitationCode = await this._cartService.getInvitationCode();
            this._cartService.setInviteCode(this._scope.invitationCode);
            this._cartService.setInvitationType(Constants.InvitationTypes.share);
            
            this._scope.submitOrder();
        }
    }

    async _submitOrder() {
        try {
            await this._groupOrderService.save();
            this._cartService.resetCart();
            this._scope.setCurrentTabById('finish');
            scopeUtils.apply(this._scope);
        } catch (error) {
            //this._scope.errorMessage = this._messageService.getMessageFromErrorResponse(error) || "Cannot update the cart";
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderSummaryPageController.js